var _mask, _path, _path2, _mask2, _path3, _path4, _mask3, _path5, _path6, _path7, _path8;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownloadEcxelIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-outside-1_9490_7071",
    maskUnits: "userSpaceOnUse",
    x: 2.2002,
    y: 7.70605,
    width: 4,
    height: 4,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 2.2002,
    y: 7.70605,
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.01309 11.1059L4.41278 10.2281L3.809 11.1059H3.2002L4.07124 9.87637L3.25438 8.70605H3.86319L4.41278 9.52637L4.95563 8.70605H5.57117L4.75431 9.87137L5.62536 11.1061L5.01309 11.1059Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.01309 11.1059L4.41278 10.2281L3.809 11.1059H3.2002L4.07124 9.87637L3.25438 8.70605H3.86319L4.41278 9.52637L4.95563 8.70605H5.57117L4.75431 9.87137L5.62536 11.1061L5.01309 11.1059Z",
    fill: "#014780"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.01309 11.1059L4.41278 10.2281L3.809 11.1059H3.2002L4.07124 9.87637L3.25438 8.70605H3.86319L4.41278 9.52637L4.95563 8.70605H5.57117L4.75431 9.87137L5.62536 11.1061L5.01309 11.1059Z",
    stroke: "#014780",
    strokeWidth: 0.2,
    mask: "url(#path-1-outside-1_9490_7071)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-outside-2_9490_7071",
    maskUnits: "userSpaceOnUse",
    x: 5.50781,
    y: 7.70605,
    width: 3,
    height: 4,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 5.50781,
    y: 7.70605,
    width: 3,
    height: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.50781 11.1061V8.70605H7.2V10.6562H8.02999V11.1061H6.50781Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.50781 11.1061V8.70605H7.2V10.6562H8.02999V11.1061H6.50781Z",
    fill: "#014780"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.50781 11.1061V8.70605H7.2V10.6562H8.02999V11.1061H6.50781Z",
    stroke: "#014780",
    strokeWidth: 0.2,
    mask: "url(#path-2-outside-2_9490_7071)"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-outside-3_9490_7071",
    maskUnits: "userSpaceOnUse",
    x: 7.7998,
    y: 7.70605,
    width: 4,
    height: 4,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 7.7998,
    y: 7.70605,
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.7998 10.7387L9.06847 10.3619C9.26141 10.5633 9.52853 10.6769 9.80749 10.6765C10.0795 10.6765 10.2121 10.5504 10.2121 10.4176C10.2121 10.0064 8.87343 10.2898 8.87343 9.41475C8.87343 9.02803 9.20112 8.70691 9.755 8.70691C10.088 8.6948 10.4129 8.81228 10.6612 9.03473L10.386 9.3968C10.2005 9.23114 9.95963 9.14066 9.71089 9.14275C9.49791 9.14275 9.38321 9.23616 9.38321 9.37536C9.38321 9.74565 10.7186 9.49827 10.7186 10.3584C10.7186 10.7844 10.4154 11.104 9.78789 11.104C9.42219 11.1236 9.06473 10.9915 8.7998 10.7387Z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.7998 10.7387L9.06847 10.3619C9.26141 10.5633 9.52853 10.6769 9.80749 10.6765C10.0795 10.6765 10.2121 10.5504 10.2121 10.4176C10.2121 10.0064 8.87343 10.2898 8.87343 9.41475C8.87343 9.02803 9.20112 8.70691 9.755 8.70691C10.088 8.6948 10.4129 8.81228 10.6612 9.03473L10.386 9.3968C10.2005 9.23114 9.95963 9.14066 9.71089 9.14275C9.49791 9.14275 9.38321 9.23616 9.38321 9.37536C9.38321 9.74565 10.7186 9.49827 10.7186 10.3584C10.7186 10.7844 10.4154 11.104 9.78789 11.104C9.42219 11.1236 9.06473 10.9915 8.7998 10.7387Z",
    fill: "#014780"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.7998 10.7387L9.06847 10.3619C9.26141 10.5633 9.52853 10.6769 9.80749 10.6765C10.0795 10.6765 10.2121 10.5504 10.2121 10.4176C10.2121 10.0064 8.87343 10.2898 8.87343 9.41475C8.87343 9.02803 9.20112 8.70691 9.755 8.70691C10.088 8.6948 10.4129 8.81228 10.6612 9.03473L10.386 9.3968C10.2005 9.23114 9.95963 9.14066 9.71089 9.14275C9.49791 9.14275 9.38321 9.23616 9.38321 9.37536C9.38321 9.74565 10.7186 9.49827 10.7186 10.3584C10.7186 10.7844 10.4154 11.104 9.78789 11.104C9.42219 11.1236 9.06473 10.9915 8.7998 10.7387Z",
    stroke: "#014780",
    strokeWidth: 0.2,
    mask: "url(#path-3-outside-3_9490_7071)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8278 16.7061L15.2002 14.0854L13.6278 14.0854L13.6304 10.8854L12.0304 10.8854L12.0304 14.0854L10.4278 14.0854L12.8278 16.7061Z",
    fill: "#014780"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0.799805 0.706055V16.7703H10.3972V15.1061H2.47141L2.3998 2.30605L7.9998 2.30605V6.30605H11.9972V9.38019L13.5972 8.24312V4.30605L9.5998 0.706055H0.799805ZM9.3213 3.05343L10.748 4.8164H9.3213V3.05343Z",
    fill: "#014780"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadEcxelIcon);
export default __webpack_public_path__ + "static/media/download_ecxel_icon.308aa6ec.svg";
export { ForwardRef as ReactComponent };